"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createFulfilledCache = exports.createRejectedCache = exports.pendingCache = exports.idleCache = void 0;
const cache = "___cache___";
const symbol = Symbol.for(cache);
exports.idleCache = { status: "idle", [cache]: symbol };
exports.pendingCache = { status: "pending", [cache]: symbol };
function createRejectedCache(error) {
    return { status: "rejected", error, [cache]: symbol };
}
exports.createRejectedCache = createRejectedCache;
function createFulfilledCache(value) {
    return { status: "fulfilled", value, [cache]: symbol };
}
exports.createFulfilledCache = createFulfilledCache;
